import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalBlsFees",
  ref: "modalEl",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_3 = { class: "modal-content border-0" }
const _hoisted_4 = { class: "modal-header border-0 pb-0" }
const _hoisted_5 = { class: "modal-title fw-bold mb-5" }
const _hoisted_6 = {
  key: 0,
  class: "fs-13 text-body-tertiary"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-center text-muted py-5"
}
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger mb-0"
}
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle mb-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "ps-0 fw-semibold" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end fw-semibold" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-end fw-bold" }
const _hoisted_19 = { class: "bg-light rounded-2 p-15 mb-20" }
const _hoisted_20 = { class: "row g-2 align-items-end" }
const _hoisted_21 = { class: "col-md-5" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "input-group-text" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table align-middle mb-0" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "ps-0 fw-semibold" }
const _hoisted_30 = {
  key: 0,
  class: "badge rounded-pill text-bg-info fs-11 ms-5"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "badge rounded-pill text-bg-light fs-13" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "input-group has-validation" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "input-group-text" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "text-end fw-bold text-primary fs-16" }
const _hoisted_39 = { class: "modal-footer border-0 pt-0" }
const _hoisted_40 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h5", _hoisted_5, " Frais du bon " + _toDisplayString($setup.note?.note_stock_ref), 1),
            ($setup.note)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.note.note_stock_agency_name) + " · " + _toDisplayString($setup.getDate($setup.note.created_at)), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "spinner-border spinner-border-sm me-5" }, null, -1),
                _createTextVNode(" Chargement... ", -1)
              ])))
            : ($setup.loadError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.loadError), 1))
              : ($setup.isDone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "alert alert-success d-flex align-items-center fs-14" }, [
                      _createElementVNode("i", { class: "flaticon-check me-8" }),
                      _createTextVNode(" Les frais de ce bon ont été ajoutés. Ils seront repris dans la prochaine facture de chaque client. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("table", _hoisted_11, [
                        _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "ps-0" }, "Client"),
                            _createElementVNode("th", null, "Désignation"),
                            _createElementVNode("th", { class: "text-end" }, "Qté"),
                            _createElementVNode("th", { class: "text-end" }, "Frais / colis"),
                            _createElementVNode("th", { class: "text-end" }, "Total"),
                            _createElementVNode("th", null, "Facture")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (!$setup.lines.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _cache[8] || (_cache[8] = [
                                _createElementVNode("td", {
                                  colspan: "6",
                                  class: "text-center text-muted ps-0"
                                }, " Aucun frais (tous les clients étaient à 0). ", -1)
                              ])))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lines, (line) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: line.id
                            }, [
                              _createElementVNode("td", _hoisted_13, _toDisplayString(line.cstmr_name), 1),
                              _createElementVNode("td", null, _toDisplayString(line.designation), 1),
                              _createElementVNode("td", _hoisted_14, _toDisplayString(line.qty), 1),
                              _createElementVNode("td", _hoisted_15, _toDisplayString($setup.money(line.price)), 1),
                              _createElementVNode("td", _hoisted_16, _toDisplayString($setup.money(line.total)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge rounded-pill fs-12 text-outline-${$setup.invoicedState(line.invoiced).variant}`)
                                }, _toDisplayString($setup.invoicedState(line.invoiced).label), 3)
                              ])
                            ]))
                          }), 128))
                        ]),
                        ($setup.lines.length)
                          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_17, [
                              _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", {
                                  colspan: "4",
                                  class: "text-end fw-bold ps-0"
                                }, "Total", -1)),
                                _createElementVNode("td", _hoisted_18, _toDisplayString($setup.money($setup.linesTotal)), 1),
                                _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("form", {
                    key: 3,
                    novalidate: "",
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label fs-13 fw-medium mb-5" }, "Désignation (tous)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.bulk.designation) = $event)),
                            type: "text",
                            class: "form-control",
                            maxlength: "150"
                          }, null, 512), [
                            [
                              _vModelText,
                              $setup.bulk.designation,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label fs-13 fw-medium mb-5" }, "Frais / colis (tous)", -1)),
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.bulk.price) = $event)),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              class: "form-control",
                              placeholder: "0.00",
                              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => ($setup.applyToAll && $setup.applyToAll(...args)), ["prevent"]), ["enter"]))
                            }, null, 544), [
                              [_vModelText, $setup.bulk.price]
                            ]),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$devis), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary w-100",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.applyToAll && $setup.applyToAll(...args)))
                          }, " Appliquer à tous ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("table", _hoisted_27, [
                        _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "ps-0" }, "Client"),
                            _createElementVNode("th", { class: "text-center" }, "Colis"),
                            _createElementVNode("th", { style: {"min-width":"260px"} }, "Désignation"),
                            _createElementVNode("th", { style: {"width":"180px"} }, "Frais / colis"),
                            _createElementVNode("th", {
                              class: "text-end",
                              style: {"width":"130px"}
                            }, "Total")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (!$setup.form.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_28, _cache[15] || (_cache[15] = [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "text-center text-muted ps-0"
                                }, "Aucun colis dans ce bon.", -1)
                              ])))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form, (row) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: row.customer_id
                            }, [
                              _createElementVNode("td", _hoisted_29, [
                                _createTextVNode(_toDisplayString(row.customer_name) + " ", 1),
                                (row.is_custom)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Personnalisé"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(row.nb_parcels), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((row.designation) = $event),
                                  type: "text",
                                  maxlength: "150",
                                  class: _normalizeClass(["form-control", { 'is-invalid': $setup.submitted && !row.designation }])
                                }, null, 10, _hoisted_33), [
                                  [
                                    _vModelText,
                                    row.designation,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_34, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                                    type: "number",
                                    min: "0",
                                    step: "0.01",
                                    class: _normalizeClass(["form-control", { 'is-invalid': $setup.submitted && !$setup.isValidPrice(row.price) }]),
                                    placeholder: "0.00"
                                  }, null, 10, _hoisted_35), [
                                    [_vModelText, row.price]
                                  ]),
                                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$devis), 1)
                                ])
                              ]),
                              _createElementVNode("td", {
                                class: _normalizeClass(["text-end fw-semibold", { 'text-body-tertiary': !$setup.rowTotal(row) }])
                              }, _toDisplayString($setup.money($setup.rowTotal(row))), 3)
                            ]))
                          }), 128))
                        ]),
                        ($setup.form.length)
                          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_37, [
                              _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", {
                                  colspan: "4",
                                  class: "text-end fw-bold ps-0"
                                }, "Total à facturer", -1)),
                                _createElementVNode("td", _hoisted_38, _toDisplayString($setup.money($setup.formTotal)), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "fs-13 text-body-tertiary mt-15 mb-0" }, " Total = nombre de colis × frais par colis. Les frais proposés sont ceux du client (personnalisés) sinon les frais généraux, modifiables. Un client laissé à 0 n'est pas facturé. Les frais ne peuvent être ajoutés qu'une seule fois par bon. ", -1))
                  ], 32))
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", _hoisted_40, _toDisplayString($setup.isDone ? "Fermer" : "Annuler"), 1),
          (!$setup.loading && !$setup.loadError && !$setup.isDone && $setup.form.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                disabled: $setup.saving,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)))
              }, [
                ($setup.saving)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42))
                  : _createCommentVNode("", true),
                _cache[19] || (_cache[19] = _createTextVNode(" Ajouter les frais ", -1))
              ], 8, _hoisted_41))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}